import Api from '@/lib/api/api';
import v5_Collection from '@/collections/v5/collection';
import AccountRole from '@/models/v5/account_role';

    // The roles available for any account
    var collection = new v5_Collection();
    collection.model = AccountRole;
    collection.url = function() { return Api.urls.accounts_roles(); };
    collection.get_developer_tier_roles = function() {
        return new v5_Collection(this.filter((role) => {
            return role.get('name') && ( 
                role.get('name').toLowerCase() === 'developer'||
                role.get('name').toLowerCase() === 'blinkup device'
            );
        }));
    };
    collection.get_evaluation_tier_roles = function () {
        return new v5_Collection(this.filter((role) => {
            return role.get('name') && (
                role.get('name').toLowerCase() === 'developer' ||
                role.get('name').toLowerCase() === 'blinkup device'||
                role.get('name').toLowerCase() === 'administrator'
            );
        }));
    };
    export default collection;

